
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
  }
})
export default class WSAPageThree extends Vue {
  @Prop() entryId: string;
  @Prop() model: any;
  formModel: WSAPageThreeModel;

  data() {
    return {
      formModel: {
        essayOneUrl: '',
        essayOneUrlData: '',
      }
    }
  }

  get uploadUrl() {
    return `/api/form/upload-wsa-media/${this.entryId}`;
  }

  @Emit('nextPage')
  async submitHandler() {
    this.formModel = {
      ...this.formModel,
      essayOneUrl: this.formModel.essayOneUrlData.results[0][0].url
    }
    return { ...this.formModel };
  }

  @Emit('previousPage')
  async handlePreviousClick() {
    this.formModel = {
      ...this.formModel,
      essayOneUrl: this.formModel.essayOneUrlData.results[0][0].url
    }
    return { ...this.formModel };
  }
}
